import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = { class: "avatar-section" }
const _hoisted_4 = { class: "avatar-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "user-name-wrapper" }
const _hoisted_7 = { class: "info-section" }
const _hoisted_8 = { class: "info-columns" }
const _hoisted_9 = { class: "info-group" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "info-group" }
const _hoisted_19 = { class: "info-item" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "info-item" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "settings-content" }
const _hoisted_26 = { class: "settings-group" }
const _hoisted_27 = { class: "settings-item" }
const _hoisted_28 = { class: "setting-control" }
const _hoisted_29 = { class: "settings-item" }
const _hoisted_30 = { class: "setting-control" }
const _hoisted_31 = { class: "settings-item" }
const _hoisted_32 = { class: "setting-control" }
const _hoisted_33 = { class: "settings-item" }
const _hoisted_34 = { class: "setting-control" }
const _hoisted_35 = { class: "settings-item danger-zone" }
const _hoisted_36 = { class: "setting-control" }
const _hoisted_37 = { class: "delete-account-dialog" }
const _hoisted_38 = {
  key: 0,
  class: "verification-section"
}
const _hoisted_39 = { class: "dialog-footer" }

import { ref, onMounted, computed, watch, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useUserStore } from '@/store/modules/user';
import { ElMessage } from 'element-plus';
import defaultAvatar from '@/assets/defualt.jpg';
import VipBadge from '@/components/VipBadge.vue';
import VipRedeemDialog from '@/components/VipRedeemDialog.vue';
import axios from 'axios';
import { resourceApi } from '@/services/api';
import { config } from '@/config/config';
import { Sunny, Moon, Monitor, Check, Bell, BellSlash, ArrowRight } from '@element-plus/icons-vue';

interface User {
  id: number;
  account: string;
  username: string;
  email: string;
  phone: string | null;
  avatarUrl: string | null;
  vip: number;
  vipExpiresAt: string | null;
  status: string;
  lastLoginAt: string;
  createdAt: string;
}

const API_BASE_URL = 'https://aivitahelper.xyz:8081';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const user = computed(() => userStore.userInfo);
const fileInput = ref<HTMLInputElement | null>(null);
const uploading = ref(false);
const avatarUrlRef = ref<string>(defaultAvatar);
const route = useRoute();
const defaultLanguage = ref('zh');
const isDarkTheme = ref(false);
const theme = computed({
  get: () => isDarkTheme.value ? 'dark' : 'light',
  set: (value) => {
    isDarkTheme.value = value === 'dark';
  }
});
const notifications = ref(true);

// 添加基础URL配置 - 使用config
const formatDate = (date: string | undefined) => {
  if (!date) return '未知';
  return new Date(date).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const handleUpgradeClick = () => {
  vipRedeemDialogVisible.value = true;
};

const vipRedeemDialogVisible = ref(false);

// 处理VIP兑换成功
const handleVipRedeemed = () => {
  // 刷新用户信息
  userStore.fetchUserInfo();
};

// 处理头像URL
const loadAvatar = async () => {
  if (!user.value?.avatarUrl) {
    avatarUrlRef.value = defaultAvatar;
    return;
  }
  
  // 如果已经是完整URL则直接返回
  if (user.value.avatarUrl.startsWith('http')) {
    avatarUrlRef.value = user.value.avatarUrl;
    return;
  }

  try {
    // 获取图片数据
    const response = await resourceApi.get(user.value.avatarUrl, {
      responseType: 'blob'
    });
    
    // 将blob转换为base64
    const reader = new FileReader();
    reader.onloadend = () => {
      avatarUrlRef.value = reader.result as string;
    };
    reader.readAsDataURL(response.data);
  } catch (error) {
    console.error('加载头像失败:', error);
    avatarUrlRef.value = defaultAvatar;
  }
};

// 监听用户信息变化
watch(() => user.value?.avatarUrl, (newAvatarUrl) => {
  if (newAvatarUrl) {
    loadAvatar();
  }
}, { immediate: true });

const triggerFileSelect = () => {
  fileInput.value?.click();
};

const handleFileChange = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  
  if (!file) return;
  
  // 验证文件类型
  if (!file.type.startsWith('image/')) {
    ElMessage.error('请选择图片文件');
    return;
  }
  
  // 验证文件大小（限制为2MB）
  if (file.size > 2 * 1024 * 1024) {
    ElMessage.error('图片大小不能超过2MB');
    return;
  }
  
  uploading.value = true;
  const formData = new FormData();
  formData.append('file', file);
  
  try {
    const response = await axios.post(`${API_BASE_URL}/api/user/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    if (response.data.code === 200) {
      // 更新用户信息以获取新的头像URL
      await userStore.fetchUserInfo();
      ElMessage.success('头像更新成功');
    } else {
      throw new Error(response.data.message || '上传失败');
    }
  } catch (error: any) {
    ElMessage.error(error.message || '头像上传失败，请重试');
  } finally {
    uploading.value = false;
    // 清除文件选择，允许选择相同文件
    if (fileInput.value) {
      fileInput.value.value = '';
    }
  }
};

const scrollToSection = async () => {
  if (route.hash) {
    await nextTick();
    const element = document.getElementById(route.hash.slice(1));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    // 如果没有hash，滚动到顶部
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

// 监听路由变化
watch(() => route.fullPath, () => {
  scrollToSection();
});

// 账号注销相关
const deleteDialogVisible = ref(false);
const showVerificationInput = ref(false);
const verificationCode = ref('');
const countdown = ref(0);
const deleting = ref(false);

// 显示注销确认对话框
const showDeleteConfirm = () => {
  deleteDialogVisible.value = true;
  showVerificationInput.value = true;
  verificationCode.value = '';
};

// 发送验证码
const sendVerificationCode = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/user/send-deletion-code`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    
    if (response.data.success) {
      ElMessage.success('验证码已发送到您的邮箱');
      // 开始倒计时
      countdown.value = 60;
      const timer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    }
  } catch (error: any) {
    ElMessage.error(error.response?.data?.message || '发送验证码失败');
  }
};

// 确认注销账号
const confirmDeleteAccount = async () => {
  if (!verificationCode.value) {
    ElMessage.warning('请输入验证码');
    return;
  }

  try {
    deleting.value = true;
    const response = await axios.post(
      `${API_BASE_URL}/api/user/delete-account?verificationCode=${verificationCode.value}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    
    if (response.data.success) {
      ElMessage.success('账号已成功注销');
      // 清除用户信息和token
      localStorage.removeItem('token');
      userStore.clearUserInfo();
      // 跳转到登录页
      router.push('/login');
    }
  } catch (error: any) {
    ElMessage.error(error.response?.data?.message || '注销账号失败');
  } finally {
    deleting.value = false;
  }
};

onMounted(() => {
  userStore.fetchUserInfo();
  scrollToSection();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[28] || (_cache[28] = _createElementVNode("h1", { class: "page-title" }, "用户资料", -1)),
    _createVNode(_component_el_card, { class: "profile-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: avatarUrlRef.value,
                alt: "用户头像",
                class: "user-avatar"
              }, null, 8, _hoisted_5),
              _createElementVNode("input", {
                type: "file",
                ref_key: "fileInput",
                ref: fileInput,
                style: {"display":"none"},
                accept: "image/*",
                onChange: handleFileChange
              }, null, 544)
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "upload-btn",
              size: "small",
              onClick: triggerFileSelect,
              loading: uploading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(uploading.value ? '上传中...' : '更换头像'), 1)
              ]),
              _: 1
            }, 8, ["loading"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", null, _toDisplayString(user.value?.username || '未知用户'), 1)
            ]),
            (user.value)
              ? (_openBlock(), _createBlock(VipBadge, {
                  key: 0,
                  level: user.value.vip,
                  "expires-at": user.value.vipExpiresAt
                }, null, 8, ["level", "expires-at"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "账号：", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(user.value?.account), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "用户名：", -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(user.value?.username), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "邮箱：", -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(user.value?.email), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "手机：", -1)),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(user.value?.phone || '未提供'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "VIP状态：", -1)),
                  _createElementVNode("span", _hoisted_20, [
                    (user.value?.vip > 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          size: "small",
                          type: "success",
                          effect: "light"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" VIP - " + _toDisplayString(formatDate(user.value.vipExpiresAt)) + " 到期 ", 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "info",
                            effect: "light"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("普通用户")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "upgrade-btn",
                            onClick: handleUpgradeClick
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode(" 立即升级 ")
                            ])),
                            _: 1
                          })
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "最后登录：", -1)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(user.value?.lastLoginAt)), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "注册时间：", -1)),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(formatDate(user.value?.createdAt)), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "section-divider" }, null, -1)),
    _cache[30] || (_cache[30] = _createElementVNode("h1", {
      class: "page-title",
      id: "settings"
    }, "设置", -1)),
    _createVNode(_component_el_card, { class: "profile-card settings-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "setting-header" }, [
                _createElementVNode("span", { class: "label" }, "界面主题"),
                _createElementVNode("span", { class: "description" }, "选择您喜欢的界面主题风格")
              ], -1)),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_el_switch, {
                  modelValue: isDarkTheme.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDarkTheme).value = $event)),
                  class: "theme-switch",
                  "active-icon": _unref(Moon),
                  "inactive-icon": _unref(Sunny),
                  "inline-prompt": "",
                  style: {"--el-switch-on-color":"#494949","--el-switch-width":"60px"}
                }, null, 8, ["modelValue", "active-icon", "inactive-icon"])
              ])
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_29, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "setting-header" }, [
                _createElementVNode("span", { class: "label" }, "通知提醒"),
                _createElementVNode("span", { class: "description" }, "开启后将收到系统通知和重要提醒")
              ], -1)),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_switch, {
                  modelValue: notifications.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notifications).value = $event)),
                  "inline-prompt": "",
                  "active-icon": _unref(Bell),
                  "inactive-icon": _unref(BellSlash),
                  class: "notification-switch",
                  style: {"--el-switch-on-color":"#67c23a","--el-switch-width":"60px"}
                }, null, 8, ["modelValue", "active-icon", "inactive-icon"])
              ])
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_31, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "setting-header" }, [
                _createElementVNode("span", { class: "label" }, "隐私政策"),
                _createElementVNode("span", { class: "description" }, "了解我们如何保护您的隐私")
              ], -1)),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_el_button, {
                  plain: "",
                  size: "default",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/privacy-policy')))
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode(" 查看详情 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_33, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "setting-header" }, [
                _createElementVNode("span", { class: "label" }, "用户协议"),
                _createElementVNode("span", { class: "description" }, "查看使用条款和服务协议")
              ], -1)),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_el_button, {
                  plain: "",
                  size: "default",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/user-agreement')))
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode(" 查看详情 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_35, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "setting-header" }, [
                _createElementVNode("span", { class: "label" }, "账号注销"),
                _createElementVNode("span", { class: "description danger-text" }, "注销后账号七日内可恢复，七日后会删除所有数据，请谨慎操作")
              ], -1)),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_button, {
                  type: "danger",
                  plain: "",
                  class: "delete-btn",
                  onClick: showDeleteConfirm
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode(" 注销账号 ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: deleteDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((deleteDialogVisible).value = $event)),
      title: "注销账号确认",
      width: "400px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_39, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            disabled: !verificationCode.value,
            loading: deleting.value,
            onClick: confirmDeleteAccount
          }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [
              _createTextVNode(" 确认注销 ")
            ])),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _cache[25] || (_cache[25] = _createElementVNode("p", { class: "warning-text" }, "注意：账号注销后将无法恢复，请谨慎操作！", -1)),
          (showVerificationInput.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_el_input, {
                  modelValue: verificationCode.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((verificationCode).value = $event)),
                  placeholder: "请输入邮箱验证码",
                  maxlength: "6",
                  class: "verification-input"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      disabled: countdown.value > 0,
                      onClick: sendVerificationCode
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(countdown.value > 0 ? `${countdown.value}s后重试` : '获取验证码'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(VipRedeemDialog, {
      visible: vipRedeemDialogVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((vipRedeemDialogVisible).value = $event)),
      onRedeemed: handleVipRedeemed
    }, null, 8, ["visible"])
  ]))
}
}

})